import { render, staticRenderFns } from "./ModalExpressRestrictions.vue?vue&type=template&id=59a6fe9a&"
import script from "./ModalExpressRestrictions.vue?vue&type=script&lang=js&"
export * from "./ModalExpressRestrictions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports